// Copia di riserva del catalogo di System, usata finché /map non risponde (system.miglioresoftware.com): id = slug di System.
// Il logo arriva dal proxy pubblico dei favicon di System, che lo cerca sul dominio di ogni app.

export interface MapApp {
  id: string;
  name: string;
  description: string;
  url: string;
  color: string;
}

export interface MapGroup {
  label: string;
  app: MapApp[];
}

export const APP_MAP: MapGroup[] = [
  {
    label: 'Piattaforma e infrastruttura',
    app: [
      { id: 'appmonitor', name: 'App Monitoring', url: 'https://appmonitor.miglioresoftware.com', color: '#ff6a00', description: 'La torre di controllo dell’ecosistema: costi, build, DNS, utenti e alert in un unico posto.' },
      { id: 'ai', name: 'AI', url: 'https://ai.miglioresoftware.com', color: '#ff6a00', description: 'Il sistema che fa da ponte alle AI ad abbonamento per esporle come API di OpenRouter' },
      { id: 'devon', name: 'Devon', url: 'https://devon.sviluppatoremigliore.com', color: '#e2570d', description: 'Assistente tecnico per sviluppo, consultazione della knowledge base e accesso rapido al know-how del team.' },
      {
        id: 'system',
        name: 'System',
        url: 'https://system.miglioresoftware.com',
        color: '#ff6a00',
        description: 'Portale dell’ecosistema applicativo: organizza il catalogo e permette di esplorarlo tramite mappa 2D, mondo 3D, galassia e volo.',
      },
      { id: 'security', name: 'Security', url: 'https://security.miglioresoftware.com', color: '#ff7a1a', description: 'Accesso centralizzato e gestione dell’identità per le applicazioni dell’ecosistema Migliore Software.' },
      { id: 'hosting', name: 'Hosting', url: 'https://hosting.miglioresoftware.com', color: '#ff944d', description: 'Pannello di controllo dell’hosting Cloudflare per domini, deployment, disponibilità e operazioni ricorrenti.' },
      {
        id: 'broker',
        name: 'Broker',
        url: 'https://broker.miglioresoftware.com',
        color: '#ff6a00',
        description: 'L’infrastruttura di scambio fra le applicazioni: nessuna parla direttamente con un’altra, tutte pubblicano fatti e consumano quelli che le riguardano.',
      },
      {
        id: 'message',
        name: 'Message',
        url: 'https://message.miglioresoftware.com',
        color: '#ff8c1a',
        description: 'Il centralino dei messaggi: le applicazioni consegnano notifiche e conversazioni ai canali esterni senza doverli conoscere.',
      },
      { id: 'calendar', name: 'Calendar', url: 'https://calendar.miglioresoftware.app', color: '#1a73e8', description: 'Calendari aziendali, disponibilità e prenotazioni per le applicazioni' },
      { id: 'mail', name: 'Mail', url: 'https://mail.miglioresoftware.com', color: '#0b57d0', description: 'Le caselle di posta dell’azienda e dei collaboratori in un unico posto, con l’AI che segnala le email importanti' },
      { id: 'contact', name: 'Contact', url: 'https://contact.miglioresoftware.com', color: '#1a73e8', description: 'L’anagrafe unica delle aziende e delle persone con cui lavoriamo, con le schede in tutte le applicazioni' },
      {
        id: 'monitor',
        name: 'Monitor',
        url: 'https://monitor.miglioresoftware.app',
        color: '#ff7a1a',
        description: 'Il controllo in un unico punto di tutta l’infrastruttura: costi dei provider, errori, log, prestazioni e allarmi di ogni applicazione',
      },
    ],
  },
  {
    label: 'Operazioni e persone',
    app: [
      {
        id: 'hr',
        name: 'HR',
        url: 'https://hr.miglioresoftware.com',
        color: '#ff6a00',
        description: 'Gestisce il ciclo di selezione e inserimento dei collaboratori: candidature, colloqui, contratti e promemoria in un unico spazio operativo.',
      },
      {
        id: 'operation',
        name: 'Operation',
        url: 'https://operation.miglioresoftware.com',
        color: '#ffa033',
        description: 'Coordina backlog, priorità, workflow e avanzamento del lavoro operativo, rendendo visibili responsabilità e stato delle attività.',
      },
      { id: 'jobfinder', name: 'Talent Radar', url: 'https://talent.sviluppatoremigliore.com', color: '#ff944d', description: 'Scouting intelligente di opportunità professionali, matching e pipeline candidature.' },
      { id: 'accounting', name: 'Accounting', url: 'https://accounting.sviluppatoremigliore.com', color: '#f59e0b', description: 'Contabilità operativa, fatture, incassi, scadenze e documenti economici in una vista ordinata.' },
      { id: 'maps', name: 'Maps', url: 'https://maps.miglioresoftware.com', color: '#ffa033', description: 'Mappa operativa di sedi, luoghi e punti utili, costruita per trovare subito dove andare.' },
    ],
  },
  {
    label: 'Vendite e clienti',
    app: [
      { id: 'sales-room', name: 'Sales', url: 'https://sales.miglioresoftware.com', color: '#ff6a00', description: 'Academy commerciale con roleplay vocale in tempo reale, coaching e archivio delle conversazioni.' },
      { id: 'crm', name: 'CRM', url: 'https://crm.miglioresoftware.com', color: '#ff7e1a', description: 'Il cuore delle relazioni: clienti, email, pipeline e follow-up in un filo unico.' },
      { id: 'outbound', name: 'Outbound', url: 'https://outbound.sviluppatoremigliore.com', color: '#ff8c1a', description: 'La macchina che riempie la pipeline con gap analysis e sequenze email personalizzate.' },
      { id: 'call-os', name: 'Call OS', url: 'https://call.miglioresoftware.com', color: '#ff8c1a', description: 'Sistema operativo delle call: registrazioni, trascrizioni, insight e follow-up in un flusso unico.' },
      {
        id: 'replyradar',
        name: 'ReplyRadar',
        url: 'https://replyradar.sviluppatoremigliore.com',
        color: '#f97316',
        description: 'Radar delle risposte commerciali che raccoglie i segnali, evidenzia le priorità e riduce i follow-up dimenticati.',
      },
      { id: 'cold-call', name: 'Cold Call', url: 'https://coldcall.sviluppatoremigliore.com', color: '#ff5f2e', description: 'Spazio operativo interno dedicato alla vendita a freddo e al lavoro sulle call settimanali.' },
      {
        id: 'connect',
        name: 'Connect',
        url: 'https://connect.miglioresoftware.com',
        color: '#ff6a00',
        description: 'Le conversazioni con i contatti in un’unica casella: WhatsApp oggi, gli altri canali domani, con le risposte che escono sempre attraverso Message.',
      },
      { id: 'lead', name: 'Lead', url: 'https://lead.miglioresoftware.com', color: '#1a73e8', description: 'Trova le aziende da contattare, le persone chiave e i loro contatti diretti, con un Lead Score spiegato' },
    ],
  },
  {
    label: 'Marketing e contenuti',
    app: [
      { id: 'brandbrain', name: 'Brand Brain', url: 'https://content.sviluppatoremigliore.com', color: '#ff9442', description: 'Crea contenuti e asset coerenti con voce, tono e identità del brand, mantenendo uniformi i diversi canali.' },
      { id: 'seo', name: 'SEO', url: 'https://seo.miglioresoftware.com', color: '#ffb347', description: 'Pianifica il lavoro SEO e raccoglie keyword, ranking e report di posizionamento per seguire la visibilità organica.' },
      { id: 'social', name: 'Social', url: 'https://social.miglioresoftware.com', color: '#ff7e1a', description: 'Gestisce creazione, calendario, programmazione e pubblicazione automatizzata dei contenuti social.' },
      { id: 'website', name: 'Website', url: 'https://sviluppatoremigliore.com', color: '#ffa033', description: 'Sito pubblico di Sviluppatore Migliore: presenta servizi e competenze, orienta la navigazione e raccoglie nuovi contatti.' },
      { id: 'amazonreport', name: 'AmazonReport', url: 'https://amazon.matteomigliore.com', color: '#ff8c1a', description: 'Report e analisi Amazon Ads per capire dove vinci e dove bruci budget.' },
      {
        id: 'video',
        name: 'Video',
        url: 'https://video.sviluppatoremigliore.com',
        color: '#ff7a2e',
        description: 'Lo studio creativo AI che trasforma un’idea in un video pronto a vendere: descrivi il concetto e l’AI scrive regia, voce, scene e montaggio. Spot social professionali in minuti.',
      },
      {
        id: 'googleads',
        name: 'Google ADS',
        url: 'https://googleads.miglioresoftware.com',
        color: '#ff9f2d',
        description: 'Il centro operativo per Google Ads: campagne, keyword, budget e segnali di conversione raccolti in una vista leggibile.',
      },
      { id: 'metads', name: 'Meta ADS', url: 'https://metads.miglioresoftware.com', color: '#ff7e1a', description: 'La plancia per Meta Ads: creatività, audience, budget e performance social advertising in un flusso unico.' },
      { id: 'webstudio', name: 'WebStudio', url: 'https://webstudio.miglioresoftware.com', color: '#e2570d', description: 'Studio web per creare, modificare e pubblicare landing page e contenuti senza uscire dall’ecosistema.' },
    ],
  },
  {
    label: 'Conoscenza e formazione',
    app: [
      { id: 'brainpower', name: 'Brain Power', url: 'https://brainpower.sviluppatoremigliore.com', color: '#ff6a00', description: 'La conoscenza che lavora per te: ricerca, sintesi e risposte operative sui tuoi contenuti.' },
      {
        id: 'digitalclone',
        name: 'DigitalClone',
        url: 'https://digitalclone.sviluppatoremigliore.com',
        color: '#ff6a00',
        description: 'Gemello digitale con memoria persistente e knowledge base, capace di rispondere in modo coerente con tono e know-how personali.',
      },
      { id: 'academy', name: 'Academy', url: 'https://academy.sviluppatoremigliore.com', color: '#ff9442', description: 'Piattaforma corsi con lezioni, percorsi e materiali didattici.' },
      { id: 'book', name: 'Book', url: 'https://book.matteomigliore.com', color: '#ffb347', description: 'Libreria personale per leggere, organizzare e ritrovare contenuti senza dispersione.' },
    ],
  },
  {
    label: 'Strumenti personali',
    app: [
      { id: 'pc', name: 'PC Manager', url: 'https://pc.miglioresoftware.com', color: '#ff8a3d', description: 'Controllo remoto del PC e delle automazioni domestiche collegate, con comandi rapidi e stato sempre visibile.' },
      { id: 'movie', name: 'Movie', url: 'https://movie.matteomigliore.com', color: '#ff7e1a', description: 'Libreria personale per organizzare un catalogo di film e riprodurli in streaming on-demand dal browser.' },
      { id: 'ipnosi', name: 'Ipnosi', url: 'https://ipnosi.matteomigliore.com', color: '#c2410c', description: 'Spazio dedicato ai percorsi di ipnosi di Matteo Migliore.' },
      { id: 'home', name: 'Home Manager', url: 'https://home.matteomigliore.com', color: '#ff8a00', description: 'Pannello personale per controllare casa, dispositivi e automazioni da un unico punto.' },
    ],
  },
  {
    label: 'Demo e prototipi',
    app: [
      { id: 'automation', name: 'Automazione', url: 'https://automazione.miglioresoftware.com', color: '#ff6a00', description: 'Automazioni operative e flussi collegati in un’unica linea di lavoro, dalla richiesta all’esecuzione.' },
      {
        id: 'demo-vision',
        name: 'Demo Vision',
        url: 'https://demo-vision.sviluppatoremigliore.com',
        color: '#ff8a00',
        description: 'Dimostrazione di Vision Sentinel per analisi visuale e riconoscimento assistito dall’intelligenza artificiale.',
      },
      { id: 'demo-sales', name: 'Demo Sales', url: 'https://demo-sales.sviluppatoremigliore.com', color: '#ff7a1a', description: 'Simulatore della rete vendita AI per provare scenari, interazioni e supporto commerciale intelligente.' },
      { id: 'demo-cqrs', name: 'Demo CQRS', url: 'https://demo-cqrs.sviluppatoremigliore.com', color: '#ff5b00', description: 'Demo tecnica EF Vision di CQRS, Event Sourcing ed Entity Framework Core resa esplorabile dal browser.' },
    ],
  },
];

export const logoUrl = (url: string) => `https://system.miglioresoftware.com/api/favicon?url=${encodeURIComponent(url)}`;
